import { z } from 'my-zod'
import { modelSystemView } from './model-system-view'

export const modelOutfitterView = modelSystemView.pick({
  id: true,
  modelNumber: true,
  productLine: true,
  modelYear: true,
  modelName: true,
  modelGroupId: true,
  lastModifiedDate: true,
  modelFamilyId: true,
  modelFamilyName: true,
  modelFamilyImageUrl: true,
  modelFamilyCapacity: true
})
export type modelOutfitterView = z.infer<typeof modelOutfitterView>
